/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/prop-types */
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { isEmpty } from 'lodash';
import InputLabel from '../../Forms/InputLabel';
// eslint-disable-next-line import/no-cycle
import {allow1Decimal, allow1Point, allow2Decimals, formatDecimal, replaceWithInt, updateStationIds} from '../helpers/helpers';
import { OpDataGrid } from 'op2mise-react-widgets';
import { chevDownWhiteIcon, pencilGreenIcon } from '../../../assets/';

function MarketSpendFields(props) {
  const {
    name,
    onChange,
    values,
    errors,
    index,
    setFieldValue,
    budget,
    objective,
    rating,
    isCampaignActive,
    toggleExpand,
    expandedId,
    expandedIds,
    marketId,
    clientGroupMarketStations,
    marketsWithoutBudget,
    setSelectedMarket,
    setShowMarketForm,
    stationIds,
    setStationIds,
    setIsFormTouched,
  } = props;

  const error = isEmpty(errors) ? {} : errors.markets[index];
  
  const handleChange = (e) => {
    // Check if input field is for allocation
    if (e.target.name.includes('allocation')) {
      // Check if campaign budget target is not null
      if (!isNaN(parseFloat(budget))) {
        const newBudgetValue = e.target.value !== ''
          ? parseFloat((budget * e.target.value) / 100)
          : '';
        setFieldValue(`markets[${index}].budgetAmount`, newBudgetValue);
      }

      // Check if campaign is op2mised by budget or rating and if
      // campaign rating target is not null
      if ((objective === 0 || objective === 2) && !isNaN(parseFloat(rating))) {
        const newRatingValue = e.target.value !== ''
          ? parseFloat((rating * e.target.value) / 100)
          : '';
        setFieldValue(`markets[${index}].targetRating`, newRatingValue);
      }
    }

    // Check if input field and campaign op2mise is budget
    // and campaign budget target is not null
    if (e.target.name.includes('budgetAmount') && !isNaN(parseFloat(budget))) {
      const newMarketAllocation = e.target.value !== ''
        ? parseFloat((e.target.value / budget) * 100).toFixed(1) || 0
        : '';

      setFieldValue(`markets[${index}].allocation`, newMarketAllocation);

      if ((objective === 0 || objective === 2) && !isNaN(parseFloat(rating))) {
        const newRatingValue = newMarketAllocation !== ''
          ? parseFloat((rating * newMarketAllocation) / 100) || 0
          : '';
        setFieldValue(`markets[${index}].targetRating`, newRatingValue);
      }
    }

    // Check if input field and campaign op2mise selection is budget or rating
    // and campaign rating target is not null
    if (
      e.target.name.includes('targetRating')
      && (objective === 0 || objective === 2)
      && !isNaN(parseFloat(rating))
    ) {
      const newMarketAllocation = e.target.value !== ''
      ? parseFloat((e.target.value / rating) * 100).toFixed(1) || 0
      : '';

      setFieldValue(`markets[${index}].allocation`, newMarketAllocation);

      if (!isNaN(parseFloat(budget))) {
        const newBudgetValue = newMarketAllocation !== ''
          ? parseFloat((budget * newMarketAllocation) / 100) || 0
          : '';
        setFieldValue(`markets[${index}].budgetAmount`, newBudgetValue);
      }
    }

    onChange(e);
  };

  const handleDecimal = (e, name) => {
    let val = e.target.value;
    const maxValue = 100;
    const decimalOnly = ['reach', 'frequency'];
    
    if (decimalOnly.includes(name))  {
        val = val.replace(/^0+/, '');
        if (val === '.0') return;
    }

    if (val.length > 1) val = val.replace(/^0+/, '');

    if (val > maxValue) return;
      val = val.replace('..', '.');

    if (val.includes('.'))  {
      const valSplit = val.split('.');
      if (valSplit[0] === '') val = `0${val}`;
    }

    e.target.value = val.replace(/^00+/, 0);
    e.target.value = allow1Point(allow1Decimal(e, val));
    handleChange(e);
  };

  const handleReachInput = (e, name) => {
    let val = e.target.value;
    const maxValue = 100;
    const decimalOnly = ['reach', 'frequency'];

    if (decimalOnly.includes(name))  {
        val = val.replace(/^0+/, '');
        if (val === '.0') return;
    }

    if (val.length > 1) val = val.replace(/^0+/, '');

    if (val > maxValue) return;
    val = val.replace('..', '.');

    if (val.includes('.')) {
      const valSplit = val.split('.');
      if (valSplit[0] === '') val = `0${val}`;
    }

    e.target.value = val.replace(/^00+/, 0);
    e.target.value = allow1Point(allow2Decimals(e, val));
    handleChange(e);
  };

  const handleAllocationInput = (e, name) => {
    let val = e.target.value;
    const maxValue = 100;

    if (val.length > 1) val = val.replace(/^0+/, '');

    if (val > maxValue) return;
    val = val.replace('..', '.');

    if (val.includes('.')) {
      const valSplit = val.split('.');
      if (valSplit[0] === '') val = `0${val}`;
    }

    e.target.value = val.replace(/^00+/, 0);
    e.target.value = allow1Point(allow2Decimals(e, val));
    handleChange(e);
  }

    const handleTrimNumeric = (val) => {
        if (val.includes('.')) {
            // eslint-disable-next-line no-param-reassign,prefer-destructuring
            val = val.split('.')[0];
        }
        return replaceWithInt(val.replace(/\D/g, ''));
    };

  const handleNumeric = (e) => {
      e.target.value = handleTrimNumeric(e.target.value);

      handleChange(e);
  };

  const columnDefs = useMemo(() => [
      {
        field: 'stationName',
        headerName: 'station/cable',
        tooltipValueGetter: (params) => params.value,
        sort: 'asc',
      },
      {
        field: 'network',
        headerName: 'network',
        tooltipValueGetter: (params) => params.value,
      },
    ], []);

    const selectionColumnDef = useMemo(() => ({
      minWidth: 75,
      width: 75,
      maxWidth: 75,
      flex: 1,
      resizable: false,
      pinned: undefined,
      lockPosition: 'right',
      suppressNavigable: true,
      suppressMovable: true,
    }), []);
  
  
  const gridRowSelectionOptions = useMemo(() => ({
    mode: 'multiRow',
    checkboxes: true,
    isRowSelectable: () => isCampaignActive,
  }), []);


  const handleOnEditMarket = (marketStations) => {

    const selectedMarket = values.find(item => item.marketId === marketId);

    selectedMarket.clientGroupMarketStations = marketStations
 
    setSelectedMarket(selectedMarket);
    setShowMarketForm(true);
  }

  // Data Grid Customize Footer
  const customFooterElement = useCallback((params) => {

    const selectedRows = params?.current?.api?.getSelectedRows();
    const selectedRowCount = selectedRows?.length

    let stations = [];
    params?.current?.api?.forEachNode(node => stations.push(node.data));

    const newStations = stations.map(item => ({...item, active: selectedRows.some(row => row.stationId === item.stationId)}))
  
    return (
      <div className={`d-flex gap-1 mt-3`}>
        <div>
          <p className="">
            {selectedRowCount || 0} Station(s) selected
          </p>
        </div>
        <div>
        <img
          alt="edit-market"
          style={{ marginLeft: '15px',   cursor: isCampaignActive ? 'pointer' : 'not-allowed' }}
          className={`action-icon ${!isCampaignActive ? 'disabled' : ''}`}
          onClick={() => {
            if(!isCampaignActive) return
            setIsFormTouched(true)
            handleOnEditMarket(newStations);
          }}
          src={pencilGreenIcon}
          title="Edit market"
        />
        </div>
      </div>
    );
  }, [expandedId, clientGroupMarketStations, values]);
  
  return (
    <div className='d-flex flex-column px-3'>
      <div className='d-flex flex-row gap-2 align-items-center'>
        {/* Chevron */}
        <div onClick={() => toggleExpand(marketId)}>
          <img
            src={chevDownWhiteIcon}
            style={{ cursor: 'pointer', height: "8px", width: "10px", filter: "invert(100%)", transform: expandedId === marketId ? "rotate(0deg)" : "rotate(-90deg)" }}
          />
        </div>
        {/* Market Split Fields */}
        <div className="d-inline-flex align-items-center r-container gap-2" style={{ width: '100%'}}>
          <div className="d-inline-flex gap-2" style={{ width: '100%'}}>
              <div className={`d-inline-flex align-items-center ${marketsWithoutBudget.includes(marketId) && 'market-error'}`} style={{ width: '30%'}}>
                  <span style={{ overflow: 'hidden', textOverflow: 'ellipsis',  whiteSpace: 'nowrap' }}>{name}</span>
              </div>
              <div className="d-inline-flex justify-content-center" style={{ width: '12%'}}>
                  <InputLabel className="text-align" maxLength={5} name={`markets[${index}].allocation`} value={values[index].allocation} onChange={handleAllocationInput} disabled={!isCampaignActive} />
              </div>
              <div className="d-inline-flex justify-content-center" style={{ width: '12%'}}>
                  <InputLabel className="text-align" maxLength={11} name={`markets[${index}].budgetAmount`} value={formatDecimal(values[index].budgetAmount)}  onChange={handleNumeric} disabled={!isCampaignActive} />
              </div>
              <div className="d-inline-flex justify-content-center" style={{ width: '12%'}}>
                <InputLabel errors={error} errorName={'targetRating'} className="text-align" maxLength={11} name={`markets[${index}].targetRating`} value={formatDecimal(values[index].targetRating)} onChange={handleNumeric} disabled={!isCampaignActive} />
              </div>
              <div className="d-inline-flex justify-content-center" style={{ width: '12%'}}>
                  <InputLabel errors={error} errorName={'reach'} className="text-align" maxLength={5} name={`markets[${index}].reach`} value={values[index].reach} onChange={(e) => handleReachInput(e, 'reach')} disabled={!isCampaignActive} />
              </div>
              <div className="d-inline-flex justify-content-center" style={{ width: '12%'}}>
                  <InputLabel errors={error} errorName={'costPerPoint'} className="text-align" maxLength={4} name={`markets[${index}].costPerPoint`} value={formatDecimal(values[index].costPerPoint)} onChange={handleNumeric} disabled={!isCampaignActive} />
              </div>
              <div className="d-inline-flex justify-content-center" style={{ width: '12%'}}>
                  <InputLabel errors={error} errorName={'frequency'} className="text-align" maxLength={4} name={`markets[${index}].frequency`} value={values[index].frequency} onChange={(e) => handleDecimal(e, 'frequency')} disabled={!isCampaignActive} />
              </div>
          </div>
        </div>
     </div>
     {/* Datagrid */}
     {expandedIds.includes(marketId) && (
        <div className='w-100 my-2' hidden={expandedId !== marketId}>
        <OpDataGrid 
          columns={columnDefs} 
          customFooterElement={customFooterElement}
          customVerbiage="No stations found"
          onGridReady={(params) => {
            params.api.selectAll();
          }}
          enableMultipleRowSelection
          gridHeightBuffer={600}
          selectionColumnDef={selectionColumnDef}
          resizable
          rowId="stationId"
          rows={clientGroupMarketStations || []}
          rowSelection={gridRowSelectionOptions}
          sharedColumnProperties={{
            flex: {fields: ['stationName', 'network'], value: 1},
            filter: {fields: ['stationName'], value: true},
            sortable: {fields: ['stationName'], value: true}, 
          }}
          key={marketId}
          onSelectionChanged={(nodes, params) => {
            // Do not execute if its from on render
            if (params.source === 'apiSelectAll') return;

            const ids = nodes.map(node => node.data.stationId) || [];
            setStationIds((prevStations) => {
              let result = [];
              if (!prevStations) {
                // Add all selected stations if prevStations is null
                result = ids.map((id) => ({
                  active: true,
                  marketId,
                  stationId: id,
                }));
              } else {
                // Modify station's active status if prevStations already has a value
                result = prevStations.map((station) => ({
                  ...station,
                  active: expandedId !== station.marketId
                    ? station.active
                    : ids.includes(station.stationId),
                }));
              }
              return result;
            });            
          }}
        />
      </div>
     )}
      
    </div>
  );
}

export default MarketSpendFields;